import React, { useEffect, useState } from 'react';
import {
  Menu, MenuList, MenuButton, IconButton,
  Flex, Box,
  Input,
  useDisclosure
} from '@chakra-ui/react';

import { RiFilter2Line, RiFilter2Fill } from "react-icons/ri";
import { CloseIcon } from '@chakra-ui/icons';

/**
 * フィルター（テキストボックス）
 * @param filterValue フィルター値
 * @param setFilterValue フィルター値設定関数
 * @param placeholder プレースホルダ
 * @returns フィルター（テキストボックス）
 */
const FilterTextBox: React.FC<any> = ({ filterValue, setFilterValue, placeholder }) => {
  /** 状態管理 */
  const { isOpen, onClose, onToggle } = useDisclosure();

  /** 入力値 */
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      // フィルター利用側からの値変更検知
      setInputValue(filterValue);
    }
  }, [filterValue]);

  /**
   * 入力が変更されたときに値を更新
   * @param event イベント情報
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  /**
   * キーダウン時に値を更新
   * @param event イベント情報
   */
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setFilterValue(inputValue);
      onClose();
    }
  }

  /**
   * フィルター値を空白にする。
   */
  const handleClear = () => {
    setInputValue('');
    setFilterValue('');
  }

  return (
    <span style={{ position: 'relative' }}>
      <Menu isOpen={isOpen} onClose={onClose} colorScheme="white" closeOnSelect={false}>
        {/* フィルターアイコン */}
        {filterValue ? <MenuButton as={IconButton} height="16px" icon={<RiFilter2Fill />} onClick={onToggle} /> : <MenuButton as={IconButton} height="16px" icon={<RiFilter2Line />} onClick={onToggle} />}

        {isOpen && (
          <>
            <MenuList boxShadow="md">
              <Box fontWeight="bold" color="black" as={Flex} margin="0px 8px">
                <Input
                  type='text'
                  placeholder={placeholder}
                  value={inputValue}
                  onBlur={(event) => setFilterValue(event.target.value)}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  backgroundColor={inputValue ? "inherit" : "#eee"}
                  borderTopRightRadius={0}
                  borderBottomRightRadius={0}
                />
                <IconButton
                  aria-label="ClearDate"
                  icon={<CloseIcon />}
                  height="40px"
                  onClick={handleClear}
                  size="sm"
                  backgroundColor={inputValue ? "inherit" : "#eee"}
                  borderTopLeftRadius={0}
                  borderBottomLeftRadius={0}
                  border="solid 1px #E2E8F0"
                />
              </Box>
            </MenuList>
          </>
        )}
      </Menu>
    </span>
  );
}

export default FilterTextBox;